<app-modal [withBox]="true" (modalClose)="closeModal(); trackConfirmHCP('close')">
    <h2>This content is for US healthcare professionals only</h2>
    <p class="modal__copy"><b>Are you a US-based healthcare professional?</b></p>
    <div *ngIf="!speciality; else specialitySelect">
        <div class="horizontal-block">
            <a>
                <app-button text="Yes" (btnClick)="chooseSpeciality()"></app-button>
            </a>
            <p>Continue to restricted content</p>
        </div>
        <div class="horizontal-block">
            <a>
                <app-button text="No" (btnClick)="closeModal(); trackConfirmHCP('no')"></app-button>
            </a>
            <p>Return to previous page</p>
        </div>
    </div>
    <ng-template #specialitySelect>
        <div class="select">
            <app-custom-select label="What is your specialty?" [options]="specialityOptions" (setSelectedAnswer)="getSelectedAnswer($event)"></app-custom-select>
        </div>
        <input *ngIf="selectedSpeciality === 'Other'" type="text" class="custom-input" placeholder="Please enter your speciality" [(ngModel)]="otherSpecialty">
        <div class="horizontal-block">
            <a class="continue">
                <app-button text="Continue" (btnClick)="submitSpecialty()" [variation]="!selectedSpeciality || selectedSpeciality === 'Other' && !otherSpecialty ? 'button--disabled' : '' "></app-button>
            </a>
        </div>
    </ng-template>
</app-modal>